import {
  Box,
  Button,
  Group,
  Modal,
  Rating,
  Stack,
  Text,
  Textarea,
  Title,
} from '@mantine/core';
import { primaryColor } from '../../../../constants/theme';

interface FeedbackFormSheetProps {
  opened: boolean;
  onClose: () => void;
  rating: number;
  onRatingChange: (value: number) => void;
  comment: string;
  onCommentChange: (value: string) => void;
  isSubmitting: boolean;
  canSubmit: boolean;
  onSubmit: () => void;
  testIdPrefix?: string;
}

export const FeedbackFormSheet = ({
  opened,
  onClose,
  rating,
  onRatingChange,
  comment,
  onCommentChange,
  isSubmitting,
  canSubmit,
  onSubmit,
  testIdPrefix = 'feedback',
}: FeedbackFormSheetProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      radius="md"
      size="lg"
      withCloseButton
    >
      <Box w="100%" maw={560} mx="auto" px="sm">
        <Stack gap={10}>
          <Title order={3} fw="normal" ta="center">
            How was your chat?
          </Title>
          <Text c="dimmed" ta="center">
            Leave a quick rating and share a note
          </Text>

          <Stack gap={4} align="center" mt={5}>
            <Rating
              value={rating}
              onChange={onRatingChange}
              count={5}
              color="yellow"
              size="lg"
              data-testid={`${testIdPrefix}-rating`}
            />
            <Text size="xs" c="dimmed">
              Tap a star to choose your rating
            </Text>
          </Stack>

          <Textarea
            label="Note"
            description="Optional"
            placeholder="Share anything you found helpful (optional)"
            value={comment}
            onChange={(event) => onCommentChange(event.currentTarget.value)}
            autosize
            minRows={4}
            maxRows={6}
            maxLength={500}
            data-testid={`${testIdPrefix}-note`}
          />

          <Text size="xs" c="dimmed" ta="right">
            {comment.length}/500
          </Text>

          <Group gap={10} justify="center">
            <Button
              variant="outline"
              w="48%"
              color={primaryColor}
              onClick={onClose}
              disabled={isSubmitting}
              data-testid={`${testIdPrefix}-cancel`}
            >
              Cancel
            </Button>
            <Button
              w="48%"
              color={primaryColor}
              onClick={onSubmit}
              loading={isSubmitting}
              loaderProps={{ color: primaryColor }}
              disabled={!canSubmit}
              data-testid={`${testIdPrefix}-submit`}
            >
              Submit
            </Button>
          </Group>
        </Stack>
      </Box>
    </Modal>
  );
};